import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import AddUserModal from "./AddUserModal";
import api from "../../api";

function AdminPanel() {
  const [patients, setPatients] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [filteredPatients, setFilteredPatients] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [patientSearch, setPatientSearch] = useState("");
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [editUser, setEditUser] = useState(null); // User being edited
  const [editType, setEditType] = useState(""); // "patients" or "employees"
  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [addUserType, setAddUserType] = useState(""); // "patients" or "employees"

  useEffect(() => {
    fetchPatients();
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchPatients = () => {
    api
      .get("/Patient/all")
      .then((response) => {
        console.log("Pobrano pacjentów:", response.data);
        setPatients(response.data);
        setFilteredPatients(response.data.slice(0, 20));
      });
  };

  const fetchEmployees = () => {
    api
      .get("/Employee/all")
      .then((response) => {
        console.log("Pobrano pracowników:", response.data);
        setEmployees(response.data);
        setFilteredEmployees(response.data.slice(0, 20));
      });
  };

  const handlePatientSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setPatientSearch(searchValue);
    const filtered = patients.filter(
      (patient) =>
        patient.name.toLowerCase().includes(searchValue) ||
        patient.surname.toLowerCase().includes(searchValue) ||
        patient.email.toLowerCase().includes(searchValue)
    );
    setFilteredPatients(filtered.slice(0, 20));
  };

  const handleEmployeeSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setEmployeeSearch(searchValue);
    const filtered = employees.filter(
      (employee) =>
        employee.name.toLowerCase().includes(searchValue) ||
        employee.surname.toLowerCase().includes(searchValue) ||
        employee.email.toLowerCase().includes(searchValue)
    );
    setFilteredEmployees(filtered.slice(0, 20));
  };

  const openEditModal = (user, type) => {
    setEditUser(user);
    setEditType(type);
    setShowModal(true);
  };

  const closeEditModal = () => {
    setEditUser(null);
    setEditType("");
    setShowModal(false);
  };

  const saveUserChanges = () => {
    console.log(`Zapisywanie zmian dla ${editType}:`, editUser);
    api.put(`/account/update/${editUser.id}`, editUser).then((response) => {
      console.log("Zaktualizowano użytkownika:", response.data);
      window.location.reload();
    });
  };

  const resetPassword = () => {
    console.log(`Resetowanie hasła dla ${editType} o ID: ${editUser.id}`);
    api
      .post(`/Auth/request-password-reset`, { email: editUser.email })
      .then((response) => {
        alert("Żądanie resetu hasła zostało wysłane pomyślnie.");
      })
      .catch((error) => {
        alert("Wystąpił błąd podczas żądania resetu hasła.");
      });
  };

  const handleAddUser = async (user) => {
    if (addUserType === "patients") {
      console.log("Dodawanie pacjenta:", user);
      try {
        await api.post("/Auth/patient", {
          pesel: user.pesel,
          name: user.name,
          surname: user.surname,
          email: user.email,
        });
        alert("Rejestracja zakończona sukcesem! Użytkownik powinien sprawdzić swój email.");
      } catch (error) {
        console.error("Błąd rejestracji:", error);
        alert("Nie udało się zarejestrować. Sprawdź swoje dane.");
      }

      setPatients([...patients, { ...user, id: patients.length + 1 }]);
    } else if (addUserType === "employees") {
      try {
        await api.post("/Auth/employee", {
          name: user.name,
          surname: user.surname,
          email: user.email,
        });
        alert("Rejestracja zakończona sukcesem! Użytkownik powinien sprawdzić swój email.");
      } catch (error) {
        console.error("Błąd rejestracji:", error);
        alert("Nie udało się zarejestrować. Sprawdź swoje dane.");
      }
      setEmployees([...employees, { ...user, id: employees.length + 1 }]);
    }
  };

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">Panel Administratora</h1>

      <div className="row">
        <div className="col-md-6">
          <section className="mb-4">
            <h2>Lista Pacjentów</h2>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Szukaj pacjentów"
              value={patientSearch}
              onChange={handlePatientSearch}
            />
            <div
              className="list-group"
              style={{ maxHeight: "300px", overflowY: "auto" }}
            >
              {filteredPatients.map((patient) => (
                <div
                  key={patient.id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div>
                    {patient.name} {patient.surname} - {patient.email}
                  </div>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => openEditModal(patient, "patients")}
                  >
                    Edytuj
                  </button>
                </div>
              ))}
            </div>
            <button
              className="btn btn-success mt-3"
              onClick={() => {
                setAddUserType("patients");
                setShowAddModal(true);
              }}
            >
              Dodaj Pacjenta
            </button>
          </section>
        </div>

        <div className="col-md-6">
          <section className="mb-4">
            <h2>Lista Pracowników</h2>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Szukaj pracowników"
              value={employeeSearch}
              onChange={handleEmployeeSearch}
            />
            <div
              className="list-group"
              style={{ maxHeight: "300px", overflowY: "auto" }}
            >
              {filteredEmployees.map((employee) => (
                <div
                  key={employee.id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div>
                    {employee.name} {employee.surname} - {employee.email}
                  </div>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => openEditModal(employee, "employees")}
                  >
                    Edytuj
                  </button>
                </div>
              ))}
            </div>
            <button
              className="btn btn-success mt-3"
              onClick={() => {
                setAddUserType("employees");
                setShowAddModal(true);
              }}
            >
              Dodaj Pracownika
            </button>
          </section>
        </div>
      </div>

      {/* Edit Modal */}
      <Modal show={showModal} onHide={closeEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            Edytuj {editType === "patients" ? "Pacjenta" : "Pracownika"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editUser && (
            <>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Imię"
                  value={editUser.name}
                  onChange={(e) =>
                    setEditUser({ ...editUser, name: e.target.value })
                  }
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nazwisko"
                  value={editUser.surname}
                  onChange={(e) =>
                    setEditUser({ ...editUser, surname: e.target.value })
                  }
                />
              </div>
              {editType === "patients" && (
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="PESEL"
                    value={editUser.pesel}
                    onChange={(e) =>
                      setEditUser({ ...editUser, pesel: e.target.value })
                    }
                  />
                </div>
              )}
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={editUser.email}
                  onChange={(e) =>
                    setEditUser({ ...editUser, email: e.target.value })
                  }
                />
              </div>
              <button className="btn btn-warning" onClick={resetPassword}>
                Zresetuj Hasło
              </button>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeEditModal}>
            Zamknij
          </Button>
          <Button variant="primary" onClick={saveUserChanges}>
            Zapisz Zmiany
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add User Modal */}
      <AddUserModal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        onAdd={handleAddUser}
        userType={addUserType}
      />
    </div>
  );
}

export default AdminPanel;